import {
    ETCD_REQUEST_GET,
    ETCD_RESPONSE_GET_SUCCESS,
    ETCD_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/etcdConstants";
  
  export const etcdShReducer = (state = { etcd: {} }, action) => {
    switch (action.type) {
      case ETCD_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case ETCD_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          etcd: action.payload,
        };
      case ETCD_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  